import { sendPostMessage, getParentWindow } from '../../utils/browserUtils';
import postMessageTypes from '../../constants/messageTypes';
// FIXME: REMOVE Once changes are made from kite
const KITE_ORIGIN = 'https://kite.zerodha.com';

/**
 * @param {{windowInstance: Window, delayMs: number}} param0
 * @returns {{promise: Promise<void>, cancel: () => void, timeoutId: number}}
 */
function onWindowClosePromise({
  windowInstance,
  delayMs = 500,
}) {
  const returnObj = {
    promise: undefined,
    cancel: undefined,
    intervalID: undefined,
  };

  returnObj.promise = new Promise(
    (resolve) => {
      returnObj.intervalID = setInterval(() => {
        if (
          (windowInstance !== undefined) &&
          windowInstance.closed
        ) {
          // cancel interval
          returnObj.cancel();
          // resolve promise
          resolve();
        }
      }, delayMs);
    },
  );

  returnObj.cancel = () => clearInterval(returnObj.intervalID);

  return returnObj;
}

/**
 * @param {{windowInstance: Window, delayMs: number}} param0
 * @returns {{promise: Promise<void>, cancel: () => void, timeoutId: number}}
 */
function onWindowCloseSendMessagePromise({
  windowInstance,
  delayMs = 500,
}) {
  const promiseObj = onWindowClosePromise({
    windowInstance,
    delayMs,
  });

  promiseObj.promise = promiseObj.promise
    .then(() => {
      sendPostMessage({
        messageType: postMessageTypes.CLOSED_WINDOW,
        messageParams: {
          windowType: 'newtab',
        },
      });
    });

  return promiseObj;
}

function setupMessageForwarding() {
  function forwardOnMessage(ev) {
    if (
      ev.data.type !== undefined &&
      ev.source !== getParentWindow()
    ) {
      // if event has type and have not originated from parent (allow only from its own children),
      // then forward it to parent
      if (ev.data.type === 'GATEWAY_LOGIN') {
        // also save the source of the event, given we have to return the message to source
        window._sourceWindow = ev.source;
      }
      sendPostMessage({
        messageType: ev.data.type,
        messageParams: {
          ...ev.data,
        },
      });
    }
  }

  window.addEventListener('message', forwardOnMessage);

  return {
    cancel: () => window.removeEventListener('message', forwardOnMessage),
  };
}

// FIXME: Remove this method when changes from kite are done
function setupKiteHoldingAuthorizationForwarding(iframeWindow) {
  function forwardOnMessage(ev) {
    if (ev.origin === KITE_ORIGIN) {
      iframeWindow.postMessage(ev.data, '*');
    }
  }
  window.addEventListener('message', forwardOnMessage);
}


export {
  onWindowCloseSendMessagePromise,
  setupMessageForwarding,
  setupKiteHoldingAuthorizationForwarding,
};



// WEBPACK FOOTER //
// ./logic/WindowManager/windowListeners.js